import { all, fork } from "redux-saga/effects";

import todoSaga from "./todo/sagas";
import apySaga from "./apy/sagas";

export function* rootSaga() {
  yield all([fork(todoSaga),fork(apySaga)]);
}